// tslint:disable:max-line-length
import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkItemModel } from '../../models/work-item';
import { WorkMenuEvent } from '../../events/work-menu-event';
import { UIMenuModel } from 'e5core-angular-services';
import { UiStyleService } from '../../services/ui-style.service';

@Component({
  selector: 'e5core-ui-work-menu-item',
  template: `
  <span [ngSwitch]="style.current()">
    <e5core-ui-work-menu-item-box (clickEvent)='onClick($event)' *ngSwitchCase='0' [workItem$]='workItem$' [menuItem]='menuItem'></e5core-ui-work-menu-item-box>
    <e5core-ui-work-menu-item-bootstrap (clickEvent)='onClick($event)' *ngSwitchCase='1' [workItem$]='workItem$' [menuItem]='menuItem'></e5core-ui-work-menu-item-bootstrap>
    <e5core-ui-work-menu-item-material (clickEvent)='onClick($event)' *ngSwitchCase='2' [workItem$]='workItem$' [menuItem]='menuItem'></e5core-ui-work-menu-item-material>
  </span>
  `,
  changeDetection: ChangeDetectionStrategy.Default
})
export class E5coreUiWorkMenuItemComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() menuItem: UIMenuModel ;

  workItemModel: WorkItemModel;

  constructor(public style:UiStyleService) { }

  ngOnInit() {
    if (this.workItem$ == null) {
      console.error('e5core-ui-work-menu-item [workItem$] must have a BehaviorSubject<WorkItemModel>');
      return ;
    }
    this.workItem$.subscribe(
      wi => {
        this.workItemModel = wi ;
      }
    );
  }

  onClick($event: WorkMenuEvent) {
    alert('You clicked ' + $event.menuCode);
  }
}
